// extracted by mini-css-extract-plugin
export default {"buttonLabel":"_1O8Q-"};